import React, { useState } from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { useMutation, useApolloClient } from '@apollo/client';
import LOGOUT_MUTATION from '@Mutations/logout_mutation.graphql';
import { node } from 'prop-types';
import { useAppConfig } from '@ApplicationWide/AppConfig';
import SessionOutModal from './SessionoutModal';
import { useModalProps } from '@kallidus/common';
import { usePreAuthConfig } from '@ApplicationWide/auth/usePreAuthConfig';

const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MILLISECONDS_IN_TWO_WEEKS = 1209600000;

export default function IdleDetection({ children }) {
  const preAuthConfig = usePreAuthConfig();
  const { company } = useAppConfig();
  const apolloClient = useApolloClient();
  const { openModal, modalProps } = useModalProps();
  const [idle, setIdle] = useState(false);

  const [logout] = useMutation(LOGOUT_MUTATION, {
    async onCompleted() {
      openModal({ loginOptions: preAuthConfig.loginOptions });
    },
  });

  const logoutIdsUser = () => {
    localStorage.clear();
    sessionStorage.clear();
    apolloClient.clearStore();
    window.location.href = `${window.baseAppConfig.bffPath}/logout`;
  };

  const onIdle = () => {
    setIdle(true);
    return !idle && (preAuthConfig.idsAuthenticationFeatureFlag ? logoutIdsUser() : logout());
  };

  return (
    <>
      <IdleTimerProvider
        timeout={
          company?.baseDetails.timeoutInterval > 0
            ? MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE * company?.baseDetails.timeoutInterval
            : MILLISECONDS_IN_TWO_WEEKS
        }
        onIdle={onIdle}
      >
        {children}
      </IdleTimerProvider>
      <SessionOutModal onIdle={setIdle} {...modalProps} className='session-out-modal' />
    </>
  );
}

IdleDetection.propTypes = {
  children: node,
};
